export const materialDownload = {
  // 页面名
  navTitle: '资料下载',

  // 标题
  sectionTitle: '产品&解决方案资料',
  sectionDesc: '涵盖各产品与解决方案完整介绍',

  // 表格
  colIndex: '序号',
  colName: '资料名称',
  colAction: '操作',
  preview: '预览',
  download: '下载',
};
